var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrafts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m204 154 30 30-67.097 67.097a20 20 0 0 1-6.715 4.428l-24.524 9.809c-8.163 3.265-16.263-4.835-12.998-12.998l9.809-24.524a20 20 0 0 1 4.428-6.715zM129 14v40c0 13.807 11.193 25 25 25h40v56.716l-71.239 71.239a40 40 0 0 0-8.855 13.429L112.459 224H44c-11.046 0-20-8.954-20-20V34c0-11.046 8.954-20 20-20zm120 125c8.284 8.284 8.284 21.716 0 30l-5 5-30-30 5-5c8.284-8.284 21.716-8.284 30 0M144 14l50 50h-40c-5.523 0-10-4.477-10-10z"
})));
export default SvgDrafts;